import React, { Children, Fragment } from 'react';
import { motion } from 'framer-motion';
const tomes = [{
  num: 1,
  color: '#22C55E',
  title: 'El Despertar Motor',
  desc: 'U4–U6 · 24 sesiones · Exploración y relación con el balón'
}, {
  num: 2,
  color: '#3B82F6',
  title: 'El ADN Técnico',
  desc: 'U7–U9 · 36 sesiones · Fundamentos técnicos individuales'
}, {
  num: 3,
  color: '#F97316',
  title: 'El Juego Inteligente',
  desc: 'U10–U12 · 48 sesiones · Táctica colectiva y análisis'
}, {
  num: 4,
  color: '#8B5CF6',
  title: 'La Especialización',
  desc: 'U13–U15 · 48 sesiones · Técnica por posición y sistemas'
}, {
  num: 5,
  color: '#EF4444',
  title: 'Rendimiento y Competición',
  desc: 'U16+ · 48 sesiones · Alto rendimiento formativo'
}, {
  num: 6,
  color: '#14B8A6',
  title: 'La Caja de Herramientas',
  desc: 'Todas las edades · 200 ejercicios · Tests · Planillas'
}];
const includes = [{
  icon: '📋',
  text: 'Planificación semanal con objetivo, ejercicios, tiempos y variantes'
}, {
  icon: '📝',
  text: 'Evaluaciones con sistema I/P/C/A y fichas de seguimiento individual'
}, {
  icon: '👤',
  text: 'Informes mensuales para padres listos para copiar y pegar'
}, {
  icon: '⚽',
  text: 'Banco de ejercicios indexados por objetivo, edad y dificultad'
}, {
  icon: '🔁',
  text: 'Variantes fácil, estándar y difícil para cada ejercicio'
}, {
  icon: '✨',
  text: 'Material original EduLabs · 100% en español neutro'
}];
export function WhatYouGet() {
  return <section className="relative w-full py-16 sm:py-24 px-4 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0a0a 0%, #080808 50%, #0a0a0a 100%)'
  }} data-id="element-349">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(34,197,94,0.03) 0%, transparent 70%)'
    }} data-id="element-350" />

      <div className="relative max-w-2xl mx-auto" data-id="element-351">
        {/* Heading */}
        <motion.div className="text-center mb-12 sm:mb-14" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-352">
          <p className="text-[#22C55E]/60 text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-353">
            TODO INCLUIDO
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-[2.75rem] font-black text-white leading-tight" data-id="element-354">
            Lo que <span className="text-[#22C55E]" data-id="element-355">recibís</span>
          </h2>
        </motion.div>

        {/* 6 Tomos card */}
        <motion.div className="bg-black/50 border border-[#22C55E]/20 rounded-2xl p-5 sm:p-7 mb-4" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-356">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-357">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#22C55E]/20" data-id="element-358" />
            <h3 className="text-[#22C55E] text-base sm:text-lg font-black tracking-wide whitespace-nowrap" data-id="element-359">
              ⚽ LOS 6 TOMOS
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-[#22C55E]/20" data-id="element-360" />
          </div>

          <motion.div className="space-y-2" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.06
            }
          }
        }} data-id="element-361">
            {tomes.map(tome => <motion.div key={tome.num} variants={{
            hidden: {
              opacity: 0,
              x: -14
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.35,
                ease: 'easeOut'
              }
            }
          }} className="group flex items-start gap-3 sm:gap-4 rounded-xl px-3.5 sm:px-4 py-3 sm:py-3.5 bg-white/[0.015] hover:bg-white/[0.04] border border-transparent hover:border-white/5 transition-all duration-300" style={{
            borderLeftWidth: 3,
            borderLeftColor: tome.color
          }} data-id="element-362">
                {/* Number badge */}
                <span className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center text-xs sm:text-sm font-black text-white mt-0.5" style={{
              backgroundColor: `${tome.color}20`,
              color: tome.color
            }} data-id="element-363">
                  {tome.num}
                </span>
                <div className="min-w-0" data-id="element-364">
                  <p className="text-white text-sm sm:text-[15px] font-bold leading-snug" data-id="element-365">
                    {tome.title}
                  </p>
                  <p className="text-gray-500 text-xs sm:text-[13px] leading-relaxed mt-0.5 group-hover:text-gray-400 transition-colors duration-300" data-id="element-366">
                    {tome.desc}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>

        {/* Summary stat bar */}
        <motion.div className="flex items-center justify-center gap-4 sm:gap-6 py-5 mb-4 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} data-id="element-367">
          {[{
          val: '+200',
          label: 'páginas'
        }, {
          val: '204',
          label: 'sesiones'
        }, {
          val: '40+',
          label: 'ejercicios'
        }, {
          val: '25+',
          label: 'plantillas'
        }].map((s, i) => <Fragment key={i} data-id="element-368">
              {i > 0 && <span className="w-px h-6 bg-gray-800" data-id="element-369" />}
              <div data-id="element-370">
                <p className="text-[#22C55E] text-lg sm:text-xl font-black leading-none" data-id="element-371">
                  {s.val}
                </p>
                <p className="text-gray-600 text-[10px] sm:text-xs font-medium uppercase tracking-wider mt-0.5" data-id="element-372">
                  {s.label}
                </p>
              </div>
            </Fragment>)}
        </motion.div>

        {/* Cada tomo incluye */}
        <motion.div className="relative bg-[#22C55E]/[0.03] border border-[#22C55E]/15 rounded-2xl p-5 sm:p-7 overflow-hidden" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-373">
          {/* Gold top accent line */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#22C55E]/40 to-transparent" data-id="element-374" />

          {/* Decorative header */}
          <div className="flex items-center justify-center gap-3 mb-6 sm:mb-7" data-id="element-375">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#22C55E]/15" data-id="element-376" />
            <h3 className="text-[#22C55E] text-base sm:text-lg font-black tracking-wide whitespace-nowrap" data-id="element-377">
              ✅ Cada tomo incluye
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-[#22C55E]/15" data-id="element-378" />
          </div>

          <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-2.5 max-w-xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.04
            }
          }
        }} data-id="element-379">
            {includes.map((item, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              y: 8
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.3,
                ease: 'easeOut'
              }
            }
          }} className="group flex items-center gap-3 text-left bg-white/[0.02] rounded-lg px-3.5 py-3 hover:bg-white/[0.05] border border-transparent hover:border-[#22C55E]/15 transition-all duration-300" style={{
            borderLeftWidth: 2,
            borderLeftColor: 'transparent'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderLeftColor = 'rgba(34,197,94,0.4)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderLeftColor = 'transparent';
          }} data-id="element-380">
                <span className="text-base flex-shrink-0 w-8 h-8 rounded-lg bg-[#22C55E]/[0.06] flex items-center justify-center group-hover:bg-[#22C55E]/[0.12] transition-colors duration-300" data-id="element-381">
                  {item.icon}
                </span>
                <span className="text-gray-400 text-[13px] sm:text-sm leading-snug group-hover:text-gray-200 transition-colors duration-300" data-id="element-382">
                  {item.text}
                </span>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}